import { connect } from 'react-redux';
import App from '../../components/App';
import { login, validate} from '../slices/userSlice';

const mapState = (state) => ({
  isConnected: state.user.isConnected,
  validation: state.user.validation,
  fetchedValidation: state.user.fetchedValidation
});

const mapDispatch = (dispatch) => ({
  login: (payload) => {
    const action = login(payload);
    dispatch(action);
  },
  validate: (data) => {
    const action = validate(data);
    dispatch(action);
  },
});

export default connect(mapState, mapDispatch)(App);
